import { render, staticRenderFns } from "./RadishInProjectList.vue?vue&type=template&id=4d10c4a4&scoped=true"
import script from "./RadishInProjectList.vue?vue&type=script&lang=js"
export * from "./RadishInProjectList.vue?vue&type=script&lang=js"
import style0 from "./RadishInProjectList.vue?vue&type=style&index=0&id=4d10c4a4&prod&lang=css"
import style1 from "./RadishInProjectList.vue?vue&type=style&index=1&id=4d10c4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10c4a4",
  null
  
)

export default component.exports